import React from 'react'
import {EmojiDict} from "../../../gd/const/item-icon/emoji/emoji";
import Emoji from "../common/emoji/emoji";
import Goal from "../../../model2/goal/goal";
import GoalProject from "../../../model2/goal/item/goal-project";
import GoalEvent from "../../../model2/goal/item/goal-event";
import GoalTask from "../../../model2/goal/item/goal-task";
import {GoalType} from "../../../model2/goal/const";
import {ItemIconClass} from "../../../gd/const/item-icon/icon/item-icon-class";
import ProjectIconUI5 from "../project/project-icon-ui5";
import {ItemIconSize} from "../@const";

// kill it use item icon size
export enum GoalIconSize {
    SIZE_13     = '13',
    SIZE_14     = '14',
    SIZE_15     = '15',
    SIZE_16     = '16',
}

type Props = {
    className?  : string

    goal        : Goal | GoalProject | GoalEvent | GoalTask

    size?       : ItemIconSize
    colorize?   : boolean

    disabled?   : boolean            // new way to disable
}

export default function GoalIconUI5(props:Props):any {

    // const size = _.get(props, 'size', '13')
    const size = _.get(props, 'size', ItemIconSize.SIZE_14) // new experimental vic


    switch (props.goal.type) {
        // case GoalType.EVENT:
        case GoalType.PROJECT:
            const projectGoal = props.goal as GoalProject;
            return <ProjectIconUI5 project={projectGoal.project} size={size} className={props.className}/>
        // case GoalType.TASK:
        //     return props.goal.icon // Eti goal models vozvrashet icon class. Stremno trogat.

        default:
            break


    }



    // EMOJI CASE
    if (!!EmojiDict[props.goal.icon]) {

        // need add black and white fiulter when disabled ?
        const classes = Classes(props.className)

        return <Emoji name={props.goal.icon} className={classes} size={size} />
    }

    // ICON CASE

    let colorClass : string | false = false
    if (props.colorize) {
        colorClass = 'gd-c-font-'+props.goal.color
    }

    const getIconClass = ()=> {
        switch (props.goal.type) {
            case GoalType.EVENT:
            case GoalType.PROJECT:
            case GoalType.TASK:
                return props.goal.icon // Eti goal models vozvrashet icon class. Stremno trogat.

            case GoalType.PARENT_GOAL:
            case GoalType.CHECKBOX:
                return ItemIconClass[props.goal.icon] || "ii5-target"
            case GoalType.COUNTER:
                return ItemIconClass[props.goal.icon] || "i5-numbers"
            case GoalType.CURRENCY:
                return ItemIconClass[props.goal.icon] || "ii5-money"
            case GoalType.PERCENT:
                return ItemIconClass[props.goal.icon] || "i5-percent"
        }
    }

    // we keep gd-ui-project-icon class as legacy need remove it in future
    const classes = Classes(
        "ui5-ico-"+size,
        getIconClass(),
        colorClass,
        props.className, {
            disabled: props.disabled,
        }
    )

    return <div className={classes}/>
}
